import { NgModule } from '@angular/core'
import { AthleteListModule } from './athletes-list/athlete-list.module'
import { CollectionsBaseModule } from '../collections/collections-base.module'
import { PeopleRoutingModule } from './people-routing.module'
@NgModule({
  imports: [PeopleRoutingModule, CollectionsBaseModule, AthleteListModule]
})
export class PeopleModule {}
